import React from 'react';

import { useLoadEvent } from 'scenes/Events/data';
import { useUpdateEvent, useCreateEvent } from 'scenes/Events/data/mutations';

import EventForm from './EventForm';
import { NAME } from './constants';

export const EventFormCreate = ({
  initialValues,
  onSubmit,
  onClose,
  onExited,
  onChange,
  open,
  ...props
}) => {
  const [createEvent, { isLoading }] = useCreateEvent();

  const handleSubmit = async values => {
    const response = await createEvent(values);
    onSubmit();
    onChange && onChange(response);
  };

  return (
    <EventForm
      title={'Add Event'}
      initialValues={initialValues}
      loading={isLoading}
      onClose={onClose}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      {...props}
    />
  );
};

export const EventFormEdit = ({
  id,
  open,
  active,
  onSubmit,
  onClose,
  onExited,
  onChange,
  ...props
}) => {
  const { data, isLoading: loading } = useLoadEvent(id);
  const [updateEvent, { isLoading }] = useUpdateEvent();

  const handleSubmit = async values => {
    await updateEvent(values);
    onSubmit();
    onChange && onChange();
  };

  return (
    <EventForm
      title={'Edit Event'}
      subTitle={data?.[NAME]}
      entityId={id}
      active={!!data}
      initialValues={data}
      loading={loading || isLoading}
      onClose={onClose}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      {...props}
    />
  );
};
